import { required, requiredIf, decimal } from 'vuelidate/lib/validators'
import { groupLevel, decimalWeight } from '@/lib/validators'

export default {
    title: {
        required,
    },
    target: {
        required: requiredIf((nestedModel) => {
            if (nestedModel.type == 'indicator') {
                return true
            }
            if (nestedModel.yearToDate) {
                return !!nestedModel.yearToDate.isCalculated
            }
        }),
        decimal,
    },
    unitOfMeasurement: {},
    weight: {
        decimal,
        decimalWeight,
    },
    activePeriod: {
        required,
    },
    owner: {
        required,
    },
    initialValue: {
        decimal,
    },
    yearToDate: {
        required,
    },
    level: {
        required,
        groupLevel,
    },
    section: {
        required: requiredIf((nestedModel) => {
            if (nestedModel.level) {
                return nestedModel.level.value != 'personal'
            }
        }),
    },
    description: {},
    rangesOfPerformance: {
        $each: {
            id: {},
            title: {},
            value: {
                decimal,
            },
            description: {},
        },
    },
    type: {},
    polarity: {},
}
